import { isValidField } from "./fieldValidator";

// utils/validators.js
// it will return func base on the input value. note: comment is an input value here
export const fieldValidators = {
  comment: (value) => {
    if (!isValidField(value, 5)) return "Enter valid comment!";
    return "";
  },
  // add more fields here as needed
  // title: (value) => { ... }
};